module.exports = __webpack_public_path__ + "img/ad5.d6edc880.jpg";